import type { LucideIcon } from "lucide-react";

interface StatCardProps {
  label: string;
  value: string;
  icon: LucideIcon;
  subtext?: string;
}

export function StatCard({ label, value, icon: Icon, subtext }: StatCardProps) {
  return (
    <article className="stat-card">
      <div className="stat-icon">
        <Icon size={20} aria-hidden />
      </div>
      <div>
        <p>{label}</p>
        <strong>{value}</strong>
        {subtext ? <span>{subtext}</span> : null}
      </div>
    </article>
  );
}
